
/**
 * 트윗 유형
 */
export type GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetById200ReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
